import React, { useEffect } from 'react';
import { Redirect, Route } from 'react-router-dom';
import { Header } from './components/Header';
import styles from './App.module.scss';
import { APP_MARKET_BASE_NAME } from './utils/constants';
import { useAppDispatch, useAppSelector } from './hooks/reduxHooks';
import { useCoreAppDispatches } from './hooks/useCoreAppDispatches';
import { AppMarketRouter } from './AppMarketRouter';
import { AppMarketPermissions, AppMode } from './models/enums';
import { NotificationContainer } from './components/Common/Notifications';
import { MerchantDelinquencyNotification } from './components/Common/MerchantDelinquencyNotification';
import { usePermission } from './hooks/usePermission';
import { Switch, useLocation } from 'react-router';
import { useAppContext } from './hooks/useAppContext';
import { appMarketApiSlice } from 'redux/api/appMarket-api-slice';
import { useAppMode } from './hooks/useAppMode';
import { CloverHeader } from './components/CloverHeader';
import { isPublicApp } from './utils/session';
import { Footer } from './components/Footer';

export const AppMarketContent = React.memo((): Nullable<JSX.Element> => {
  const {
    enabled: permissionToAccessAppMarket,
    isLoading: loadingPermissions,
  } = usePermission(AppMarketPermissions.Access);
  const { loggedOut, globalNotification } = useAppSelector(state => state.appMarketReduxState);
  const { logout } = useCoreAppDispatches();
  const location = useLocation();
  const merchantId = useAppContext()?.id || '';
  const appMode = useAppMode();

  const reduxDispatch = useAppDispatch();

  useEffect(() => {
    reduxDispatch(appMarketApiSlice.util.resetApiState());
  }, [reduxDispatch]);

  if (loggedOut && appMode === AppMode.Private) logout?.();
  if(isPublicApp()) {document.body.style.overflow='auto'} // to provide scroll in logged out view
  if (loggedOut || loadingPermissions) return null;
  else if (!permissionToAccessAppMarket) return (
    <Redirect push={false} to={{
      pathname: `/home/merchant/${merchantId}?notification=noPermission&fromApp=COM.CLOVER.APPS`,
      state: { from: location.pathname },
    }} />
  );
  else {
    return (
      <>
      {isPublicApp() &&
       <CloverHeader/>}
      <div data-testid={merchantId ? 'private-app-market' : 'public-app-market'}>
        <div className={styles.maxWidthWrapper}>
          {
            globalNotification &&
            <NotificationContainer
              className={styles.globalNotification}
              notificationProperties={globalNotification.notificationProperties}
              notificationData={globalNotification.notificationData}
            />
          }

            <Header />
            <MerchantDelinquencyNotification className={styles.delinquentMerchantNotification} />
            <div className={styles.switchContent}>
              <Switch>
                <Redirect from="/:url*(/+)" to={`/${APP_MARKET_BASE_NAME}`} />
                <Route path={[`/${APP_MARKET_BASE_NAME}/m/:mId`, `/${APP_MARKET_BASE_NAME}`]}>
                  <AppMarketRouter />
                </Route>
              </Switch>
            </div>
          </div>
        </div>
        {isPublicApp() && <Footer />}
      </>
    );
  }
});
